import { isDefined } from "@clipboard-health/util-ts";
import { useAgentProfile } from "@src/appV2/Agents/api/useAgentProfile";
import { useFutureShifts } from "@src/appV2/Shifts/MyShifts/api/useFutureShifts";
import { useNextTwoDaysShifts } from "@src/appV2/Shifts/MyShifts/api/useNextTwoDaysShifts";
import moment from "moment-timezone";

import { ShiftsList } from "./shiftsList";

export { MyShiftDetailsPage } from "./shiftDetails";

export const MyShiftList = () => {
  const { isLoading: isAgentProfileLoading, data: agentProfile } = useAgentProfile();

  const {
    isLoading: isLoadingNextTwoDaysShifts,
    data: nextTwoDaysShiftsData,
    refetch: refetchNextTwoDaysShifts,
  } = useNextTwoDaysShifts(agentProfile?.tmz ?? "", { enabled: isDefined(agentProfile?.tmz) });

  const {
    isLoading: isLoadingFutureShifts,
    data: futureShiftsData,
    refetch: refetchFutureShifts,
  } = useFutureShifts(agentProfile?.tmz ?? "", { enabled: isDefined(agentProfile?.tmz) });

  const nextTwoDaysShifts = nextTwoDaysShiftsData?.response ?? [];
  const futureShifts = futureShiftsData?.response ?? [];

  const sortedShifts = [...nextTwoDaysShifts, ...futureShifts].sort(
    (a, b) => moment(a.start).valueOf() - moment(b.start).valueOf()
  );

  const isLoading = isLoadingNextTwoDaysShifts || isAgentProfileLoading || isLoadingFutureShifts;

  return (
    <ShiftsList
      shifts={sortedShifts}
      onRefresh={async () => {
        await Promise.all([refetchNextTwoDaysShifts, refetchFutureShifts]);
      }}
      isLoading={isLoading}
    />
  );
};
